import React from "react";
import Components from "mpm-components";
import { Form, Divider } from "semantic-ui-react";

import * as Constants from "mpm-config/Constants";
import Utilities from "mpm-config/Utilities";

export default ({ cessionCapture }) => {
    return (
      <Components.Regions.RegionWithHeader
        title="menu.cession.capture"
        headerColor="blue"
        headerSize="small"
      >
        <Form>
          <Form.Group widths="equal">
            <Form.Input
              label="Numéro Cession Complet"
              disabled
              value={cessionCapture.numeroCessionComplet}
            />
            <Form.Input
              label="Date Cession "
              disabled
              value={cessionCapture.dateCession}
            />
  
            <Form.Input
              label="Date Système "
              disabled
              value={cessionCapture.dateSysteme}
            />
          </Form.Group>
          <Divider />
          <Form.Group widths="equal">
          <Form.Select
            label="Type Acquereur"
            options={Utilities.getTypeAcquereurCCDropDownOptions()}
            disabled
            value={cessionCapture.acquereurCCDTO.typeAcquereur}
          />
          <Form.Input
                label="Numéro Autorisation"
                disabled
                value={cessionCapture.acquereurCCDTO.numeroAutorisation}
              />
              <Form.Input
                label="Numéro Agrement"
                disabled
                value={cessionCapture.acquereurCCDTO.numeroAgrement}
              />
          </Form.Group>
          
  
          <Form.Group widths="equal">
            <Form.Input
              label="Login Acquereur"
              disabled
              value={cessionCapture.acquereurCCDTO.numeroAcquereur}
            />
            {cessionCapture.typeAcquereur !== Constants.CODE_ACQU_USINIER && (
              <>
                <Form.Input
                  label="Prénom Acquéreur"
                  disabled
                  value={cessionCapture.acquereurCCDTO.prenom}
                />
  
                <Form.Input
                  label="Nom Acquéreur"
                  disabled
                  value={cessionCapture.acquereurCCDTO.nom}
                />
              </>
            )}
          </Form.Group>
  
          <Form.Input
            label="Raison Social Acquéreur"
            disabled
            value={cessionCapture.acquereurCCDTO.raisonSocialeFR}
          />
        </Form>
      </Components.Regions.RegionWithHeader>
    );
  };